import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { OrderDetailContent } from "./OrderDetailContent";

interface OrderSidePanelProps {
  guidOrderId: string | null;
  wasResolved: boolean;
  onClose: () => void;
  /** When false, hide the AttachOrderForm section entirely (read-only panel). Default true. */
  showAttachForm?: boolean;
  /**
   * When true, render a read-only summary of the AssociatedMetaData (expected
   * types, OTC contract, crop year, should_ignore, customer splits) between
   * the Order Context and Order Events sections. Default false.
   *
   * Used by Active Orders where the form is hidden but the user still wants
   * to see what was previously associated.
   */
  showAssociatedMetadata?: boolean;
}

export function OrderSidePanel({
  guidOrderId,
  wasResolved,
  onClose,
  showAttachForm = true,
  showAssociatedMetadata = false,
}: OrderSidePanelProps) {
  // ESC closes the panel.
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between p-3 border-b">
        <h3 className="text-sm font-semibold">Order Details</h3>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto p-3">
        <OrderDetailContent
          guidOrderId={guidOrderId}
          wasResolved={wasResolved}
          showAttachForm={showAttachForm}
          showAssociatedMetadata={showAssociatedMetadata}
        />
      </div>
    </div>
  );
}
